import { roadB1 } from "../../utils/roadB1";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapB1 = (props) => <RoadMapGeneric {...props} roadData={roadB1} />;

export default RoadMapB1;